module.exports = __webpack_public_path__ + "img/title_zh.7bda7ed9.png";